module.exports = __webpack_public_path__ + "static/Abacus Pages 2020 Abacus HR AKB-9c1e1431e93f5a807fa46b65b8b4c1d7.pdf";